import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LanguageService } from '../parameters';

@Injectable({
  providedIn: 'root'
})
export class LangInterceptorService implements HttpInterceptor {

  constructor(
    private langService: LanguageService
  ) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const value = this.langService.get();
    if (value) {
      request = request.clone({
        setHeaders: { lang: value }
      });
    }
    return next.handle(request);
  }
}
